import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useRouter } from 'next/router';
import SubHeader from 'components/common/SubHeader';
import PlaceDetailService from 'components/branch/_place_detail';
import { spaceActions } from 'store/space';
import { GetBranchAPI, GetRegionsAPI } from 'api/space';
import { SubHeaderOptions } from 'constants/index';

var PlaceDetail = function PlaceDetail() {
  var router = useRouter();

  if (router.isFallback) {
    return /*#__PURE__*/_jsx("div", {
      children: "Loading..."
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SubHeader, {
      options: SubHeaderOptions,
      selected: "\uC9C0\uC810"
    }), /*#__PURE__*/_jsx(PlaceDetailService, {})]
  });
};

PlaceDetail.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var store, query, place, _yield$GetBranchAPI, data, regions;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = _ref.store, query = _ref.query;
            place = query.place;
            _context.next = 4;
            return GetBranchAPI(place);

          case 4:
            _yield$GetBranchAPI = _context.sent;
            data = _yield$GetBranchAPI.data;
            _context.next = 8;
            return GetRegionsAPI();

          case 8:
            regions = _context.sent;
            store.dispatch(spaceActions.getBranch(data));
            store.dispatch(spaceActions.getRegions(regions.data));
            return _context.abrupt("return", {
              place: place
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

export default PlaceDetail;